/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Protein_QuestionInputs */

const en_us2_improve_protein_question = /** @type {(inputs: Improve_Protein_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many meals a day have a good protein source?`)
};

const pt_br2_improve_protein_question = /** @type {(inputs: Improve_Protein_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas refeições por dia têm uma boa fonte de proteína?`)
};

const es_419_improve_protein_question = /** @type {(inputs: Improve_Protein_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántas comidas al día tienen una buena fuente de proteína?`)
};

const pt_pt2_improve_protein_question = /** @type {(inputs: Improve_Protein_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas refeições por dia têm uma boa fonte de proteína?`)
};

const fr_fr2_improve_protein_question = /** @type {(inputs: Improve_Protein_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de repas par jour contiennent une bonne source de protéines ?`)
};

const de_de2_improve_protein_question = /** @type {(inputs: Improve_Protein_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Mahlzeiten am Tag haben eine gute Eiweißquelle?`)
};

const it_it2_improve_protein_question = /** @type {(inputs: Improve_Protein_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti pasti al giorno hanno una buona fonte di proteine?`)
};

/**
* | output |
* | --- |
* | "How many meals a day have a good protein source?" |
*
* @param {Improve_Protein_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_protein_question = /** @type {((inputs?: Improve_Protein_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Protein_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_protein_question(inputs)
	if (locale === "es-419") return es_419_improve_protein_question(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_protein_question(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_protein_question(inputs)
	if (locale === "de-DE") return de_de2_improve_protein_question(inputs)
	if (locale === "it-IT") return it_it2_improve_protein_question(inputs)
	return en_us2_improve_protein_question(inputs)
});
export { improve_protein_question as "improve.protein.question" }